import React, { useEffect, useState, useCallback, useMemo } from 'react';
import {
    Box,
    Typography,
    Container,
    Card,
    Grid,
    Tabs,
    Tab,
    FormControl,
    InputLabel as MuiInputLabel,
    MenuItem,
    TextField,
    Select,
    Checkbox,
    Tooltip,
    Button,
    OutlinedInput,
    Stack,
    Snackbar,
    useMediaQuery
} from '@mui/material';
import Alert, { AlertProps } from '@mui/material/Alert';
import { InputLabel } from '../../../home/Home-components';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import {
    getMatrixType,
    getSearchTest,
    deleteQuoteTest,
    getPriceTableName,
    getResultTableNames,
    getResultTableData,
    getUpdateQuoteTest,
    getLabLocations,
    getAllTestFromPriceList,
    getMatchedPriceList,
    addQuoteTestToResultTable,
    getBillingGroupTest,
    getTestOfBillingGroup,
    updateTestSampleNo,
    getQuotetestGroup,
    getSuiteList
} from 'services';
import { AddPriceTable } from './InnerComponent';
import { ResultPage } from './ResultPage';
import PriceList from './PriceList';
import { useTheme } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import ControlPointOutlinedIcon from '@mui/icons-material/ControlPointOutlined';
import SingleRowExpand from './AnalysisGrid/SingleRowExpand';
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
import ContentPasteSearchOutlinedIcon from '@mui/icons-material/ContentPasteSearchOutlined';
import { DeletePrompt } from './InnerComponent';
import { debounce } from "lodash";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: Readonly<TabPanelProps>) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

let a11yProps = (index: number) => {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export const AnalysisFees = ({
    getPriceListId,
    analysisFeeResponse,
    updateAddStatus,
    quoteId,
    resultTableStatus,
    parentGetRow,
    summaryStatus,
    showSummaryTable,
    getPriceTableResult,
    isEdit,
    setAnalysisFeeResponse,
    handleSubmit,
    analysisGridLoad,
    isRequired,
    errorCheck,
    paramId,
    loading,
    saveAllTrigger
}: any) => {
    const [labLocationList, setLabLocationList] = useState([] as any[]);
    const [searchValue, setSearchValue] = useState('');
    const [testName, setTestName] = React.useState<any | null>(null);
    const [testId, setTestId] = useState('');
    const [updateErrorMsg, setUpdateErrorMsg] = useState('');
    const [matrixType, setMatrixType] = useState([] as any[]);
    const [testList, setTestList] = useState([] as any[]);
    const [priceList, setPriceList] = useState({
        testListData: []
    });
    const [getSelectedRowId, setGetSelectedRowId] = useState([] as any[]);
    const [selectedMatrixType, setSelectedMatrixType] = useState([] as any[]);
    const [value, setValue] = useState(0);
    const [addPriceTableStatus, setAddPriceTableStatus] = useState(false);
    const [isRowUpdate, setIsRowUpdate] = useState(false);
    const [isMatchResult, setIsMatchResult] = useState(true);
    const [deleteError, setDeleteError] = useState(false);
    const [currentTabStatus, setCurrentTabStatus] = useState(1);
    const [priceTables, setPriceTables] = useState([] as any[]);
    const [resultTableNames, setResultTableNames] = useState([] as any[]);
    const [rowCount, setRowCount] = useState(1);
    const [selectedPriceMatrixType, setSelectedPriceMatrixType] = useState(1);
    const [priceSearchValue, setPriceSearchValue] = useState('');
    const [priceLocationId, setPriceLocationId] = useState(0);
    const [pageNo, setPageNo] = useState(0);
    const [isUpdateError, setIsUpdateError] = useState(false);
    const [snackbar, setSnackbar] = useState<Pick<
        AlertProps,
        'children' | 'severity'
    > | null>(null);
    const [sameTestExist, setSameTestExist] = useState(false);
    const [isBillingGroup, setIsBillingGroup] = useState(false);
    const [billingGroupEnablePopup, setBillingGroupEnablePopup] = useState(false);
    const [isRowDeleted, setIsRowDeleted] = useState(false);
    const [isEnablePriceTable, setIsEnablePriceTable] = useState(false);
    const [notFoundError, setNotFoundError] = useState(false);
    const [resetSelectedIds, setResetSelectedIds] = useState(0);
    const [enableAddOnCheckbox, setEnableAddOnCheckbox] = useState(false);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [idSelected, setIdSelected] = useState('');
    const [selectionTrigger, setSelectionTrigger] = useState(0);
    const [selectionTriggerMisc, setSelectionTriggerMisc] = useState(0);
    const [selectedMetal, setSelectedMetal] = useState({
        name: '',
        id: ''
    });
    const [billingGroupTestList, setBillingGroupTestList] = useState([] as any[]);
    const [hasChargesStatus, setHasChargesStatus] = useState(1);
    const [billingGroupIds, setBillingGroupIds] = useState('');
    const [billingGroupList, setBillingGroupList] = useState([] as any[]);
    const [getQuoteTestGroupList, setGetQuoteTestGroupList] = useState([] as any[]);
    const [selectedSuiteList, setSelectedSuiteList] = useState([] as any[]);
    const [selectedIsSet, setSelectedIsSet] = useState();
    const [searchInPriceList, setSearchInPriceList] = useState(true);
    const [quoteTestGroupId, setQuoteTestGroupId] = useState(0);
    const [resultData, setResultData] = useState([] as any[]);
    const [notificationMsg, setNotificationMsg] = useState({
        open: false,
        type: '',
        message: ''
    });

    const dispatch = useDispatch();
    let searchResult: any = useSelector((state: any) => state.searchResult);

    useEffect(() => {
        if ((paramId !== '') || (paramId !== null)) {
            onLoadApi();
        }
    }, [])

    let reset = isEdit ? 1 : 0;

    useEffect(() => {
        if (reset !== 1) {
            setResultData([]);
            setResultTableNames([]);
            setAnalysisFeeResponse([]);
        }
    }, [reset])

    useEffect(() => {
        if (analysisFeeResponse) {
            setAnalysisFeeResponse(analysisFeeResponse);
        }
    }, [analysisFeeResponse])

    useEffect(() => {
        setTestName(null);
    }, [analysisFeeResponse])

    useEffect(() => {
        if (value === 1 && quoteId === '') {
            handleSubmit('priceList');
        }
    }, [value])

    useEffect(() => {
        reloadGrid();
    }, [value, currentTabStatus, quoteId])

    const reloadGrid = () => {
        if (paramId !== null || quoteId !== null) {
            if (value === 0 && currentTabStatus) {
                analysisGridLoad(paramId);
            }
        } else {
            analysisGridLoad(quoteId);
        }
    }

    const onLoadApi = () => {
        let id = paramId !== null ? paramId : quoteId;
        if (id) {
            getResultTableNames(id).then((res: any) => {
                if (res.status === 200) {
                    setResultTableNames(res.data);
                }
            });
            loadResultTableData();
        }
    }

    const loadResultTableData = () => {
        let id = paramId !== null ? paramId : quoteId;
        if (id) {
            getResultTableData(id).then((res: any) => {
                if (res.status === 200) {
                    setResultData(res.data);
                }
            });
        }
    }

    useEffect(() => {
        loadResultTableData();
    }, [selectionTriggerMisc]);

    useEffect(() => {
        if (quoteId && testName) {
            getQuotetestGroup(quoteId).then((res: any) => {
                if (res.status === 200) {
                    setGetQuoteTestGroupList(res.data);
                }
            });
        } else {
            setGetQuoteTestGroupList([{ item1: "Add New", item2: -1 }]);
        }
    }, [testName])

    useEffect(() => {
        getMatrixType().then((res: any) => {
            setMatrixType(res.data);
        });
        getLabLocations().then((res: any) => {
            if (res.status === 200) {
                setLabLocationList(res.data);
            }
        });
    }, [])

    const debounceFetch = useMemo(
        () =>
            debounce(async (searchValue, selectedMatrixType) => {
                let priceListId = searchInPriceList ? getPriceListId : -1;
                const hasMatrixType = Array.isArray(selectedMatrixType) ? selectedMatrixType.length > 0 : !!selectedMatrixType;
                if (searchValue?.length >= 2 && hasMatrixType) {
                    getSearchTest(selectedMatrixType, searchValue, priceListId).then((res: any) => {
                        if (res.status === 200) {
                            let itList: any = [];
                            res.data.map((el: any) => {
                                let obj = {
                                    id: el.id,
                                    name: el.name,
                                    label: el.name,
                                }
                                itList.push(obj);
                            });
                            setTestList(res.data);
                        }
                    }).finally(() => {
                        // Catch block
                    })
                }
            }, 500),
        [searchInPriceList, getPriceListId]
    );

    useEffect(() => {
        if (searchValue) {
            debounceFetch(searchValue, selectedMatrixType)
        } else {
            setTestList([])
        }
        return () => {
            debounceFetch.cancel();
        };
    }, [searchValue, debounceFetch])

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
        setGetSelectedRowId([]);
        dispatch({ type: 'SEARCH_RESULT', payload: 0 });
        setPriceSearchValue('');
    };

    const currentRowUpdate = (selected: any) => {
        setAnalysisFeeResponse(selected);
    }

    const handleUpdate = useCallback(async (row: any, sender: any) => {
        try {
            let testPricePayload = {
                id: row.id,
                quoteID: row.quoteID,
                testPrice: row.testPrice,
            }
            let updateApi = sender === 'SampleNo' ? updateTestSampleNo(row) : getUpdateQuoteTest(testPricePayload);
            updateApi.then((res: any) => {
                if (res.status === 200) {
                    setIsRowUpdate(true);
                    setIsUpdateError(false);
                    setAnalysisFeeResponse(prevData => {
                        if (JSON.stringify(prevData) !== JSON.stringify(res.data)) {
                            return res.data;
                        }
                        return prevData;
                    });
                } else if (res.status === 400) {
                    setIsUpdateError(true);
                    let errorMsg = sender === 'SampleNo' ? 'Sample number should be greater than zero!' : 'Test Price should be greater than zero!'
                    setUpdateErrorMsg(errorMsg);
                }
            });
        } catch (error: any) {
            // error;
        } finally {
            // loading...;
        }
    }, [])

    useEffect(() => {
        if (idSelected) {
            handleSelectedSuite();
        }
    }, [idSelected, selectionTrigger]);

    const handleIdSelection = (id: string) => {
        setIdSelected(id);
        setSelectionTrigger(prev => prev + 1);
    };

    const handleSelectedSuite = () => {
        getSuiteList(idSelected).then((res: any) => {
            if (res.status === 200) {
                setSelectedSuiteList(res.data);
            } else {
                setNotificationMsg({ open: true, type: 'error', message: res.data || 'Failed to fetch suite list' });
            }
        }).catch((error: any) => {
            setNotificationMsg({ open: true, type: 'error', message: error.message || 'An error occurred while fetching suite list' });
        });
    }

    const addSubmit = () => {
        let obj = {
            "status": true,
            "quoteID": quoteId,
            "testIDs": testId.toString().concat(", ", billingGroupIds),
            "matrixTypeID": selectedMatrixType,
            "billingGroupID": isBillingGroup && (billingGroupList.length > 0 || quoteTestGroupId !== 0) ? selectedMetal?.id : 0,
            "priceListID": getPriceListId,
            'HasCharges': hasChargesStatus,
            'quotesTestGroupID': isBillingGroup ? quoteTestGroupId : 0
        }
        updateAddStatus(obj);
        setBillingGroupList([]);
        setBillingGroupIds('');
        setQuoteTestGroupId(0);
        setIsBillingGroup(false);
        setTestName(null);
        setTestId('');
        setGetSelectedRowId([]);
    }

    const selectedRowDelete = () => {
        let isChildStatus = false;
        getSelectedRowId.forEach((j: any) => {
            analysisFeeResponse.forEach((i: any) => {
                if (i.isSelectAll || (i.id === j && i.linkedTests === null)) {
                    setBillingGroupEnablePopup(false);
                    isChildStatus = true
                }
                else {
                    i?.linkedTests?.forEach((k: any) => {
                        if (j === k.id && k.testID > 0 && k.billingGroupID > 0 && k.code !== 'Grouped') {
                            setBillingGroupEnablePopup(true);
                            isChildStatus = false;
                        }
                    })
                }
            })
        })

        if (isChildStatus) {
            handleTableDelete();
        }
    }

    const handleTableDelete = () => {
        let selectedObj = {
            "quoteTestIDList": getSelectedRowId,
            "priceListID": getPriceListId,
            "quoteId": quoteId
        }
        deleteQuoteTest({ data: selectedObj }).then((res: any) => {
            if (res.status === 200) {
                setAnalysisFeeResponse(res.data);
                setAnalysisFeeResponse(res.data);
                setGetSelectedRowId([]);
                setBillingGroupEnablePopup(false);
                setIsRowDeleted(true);
            } else if (res.status === 400) {
                setDeleteError(true);
                setIsRowDeleted(false);
            }
        });
    }

    useEffect(() => {
        if (resultTableStatus && addPriceTableStatus) {
            priceTableName(quoteId);
        }
    }, [resultTableStatus, addPriceTableStatus])

    const priceTableName = (quoteId: any) => {
        if (quoteId) {
            getPriceTableName(quoteId).then((res: any) => {
                if (res.status === 200) {
                    setPriceTables(res.data);
                }
            });
        }
    }

    const handleAddToPriceTable = () => {
        let rowItems: any = undefinedRemoved(analysisFeeResponse);
        const unique2 = rowItems.filter((obj, index) => {
            return index === rowItems.findIndex(o => obj.id === o.id && obj.testName === o.testName);
        });
        const selectedItem = getSelectedRowId?.map((i: any) => unique2?.find((row: any) => row.id === i));
        let filterItems: any = undefinedRemoved(selectedItem);

        // Check if all selected items meet the conditions for Add-On checkbox
        const shouldEnableAddOn = filterItems.every((item: any) =>
            item.isSet === false
        );
        setEnableAddOnCheckbox(shouldEnableAddOn);
        setAddPriceTableStatus(true);
    }

    const handleCloseAddPriceTable = () => {
        setAddPriceTableStatus(false);
        handleIdSelection('');
    }

    const undefinedRemoved = (selectedRowItems: any) => {
        let filterValue = selectedRowItems.filter((element: any) => {
            return element !== undefined;
        })
        return filterValue;
    }

    const analysisGetRow = (val: any) => {
        parentGetRow(val);
        let items: any = [];
        val.map((i: any) => {
            items.push(i);
        });
        const ids = items.map(({ id }) => id);
        const filtered = items.filter(({ id }, index) => !ids.includes(id, index + 1));
        setResultData(filtered);
    }

    const summaryUpdateStatus = (val: any) => {
        summaryStatus(val);
    }

    const tabStatus = (val: any) => {
        setCurrentTabStatus(val);
    }

    const handleCheckbox = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            setIsMatchResult(true);
        } else {
            setIsMatchResult(false);
        }
    }

    const getPageNo = (page: any) => {
        setPageNo(page);
    }

    const addPriceListSubmit = () => {
        setPriceList({ testListData: [] });
        if (searchResult && quoteId) {
            let initialPage = pageNo + 1;
            let addText = priceSearchValue.length > 0 ? priceSearchValue : '';
            if (isMatchResult) {
                getAllTestFromPriceList(selectedPriceMatrixType, getPriceListId, initialPage, quoteId, addText, priceLocationId).then((res: any) => {
                    if (res.status === 200) {
                        setPriceList(res.data);
                        handleRowCount(res);
                        setNotFoundError(false);
                    } else {
                        setNotFoundError(true);
                        setPriceList({ testListData: [] });
                    }
                });
            } else {
                getMatchedPriceList(selectedPriceMatrixType, getPriceListId, initialPage, quoteId, addText).then((res: any) => {
                    if (res.status === 200) {
                        setPriceList(res.data);
                        handleRowCount(res);
                        setNotFoundError(false);
                    } else {
                        setNotFoundError(true);
                        setPriceList({ testListData: [] });
                    }
                });
            }
        }
    }

    const handleRowCount = (item: any) => {
        let count = item.data.testListData.map((item: any) => {
            setRowCount(item.totalTestsCount);
        })
        return count;
    }

    useEffect(() => {
        addPriceListSubmit();
    }, [pageNo, searchResult])

    let enableAddTestCheck = false;
    if (isBillingGroup) {
        if (selectedMatrixType && testName && isRequired && errorCheck) {
            if (billingGroupIds) {
                enableAddTestCheck = quoteTestGroupId !== 0;
            } else {
                enableAddTestCheck = true;
            }
        }
    } else {
        if (selectedMatrixType && testName && isRequired && errorCheck) {
            enableAddTestCheck = true;
        }
    }

    let enableSearchCheck = false;
    if (selectedPriceMatrixType && (priceLocationId !== null) && isMatchResult && (priceSearchValue.length > 0)) {
        enableSearchCheck = true;
    } else if (selectedPriceMatrixType && priceLocationId !== null && !isMatchResult) {
        enableSearchCheck = true;
    } else {
        enableSearchCheck = false;
    }

    const submitPriceTable = (samplesNo: any, selectedSuite: any) => {
        let loadItems: any = [];
        getSelectedRowId.map((i: any) => {
            let obj = {
                "quoteResultTableID": idSelected,
                "quoteTestID": i,
                "quoteID": quoteId,
                "noOfSamples": samplesNo,
                "addedToTest": selectedSuite
            }
            return loadItems.push(obj);
        })

        setResetSelectedIds(0);
        addQuoteTestToResultTable(loadItems).then((res: any) => {
            if (res.status === 200) {
                analysisGetRow(res.data);
                analysisFeeResponse.map((i: any) => {
                    i.isSelected = false;
                    if (i?.linkedTests?.length > 0) {
                        i.linkedTests.map((j: any) => {
                            j.isSelected = false;
                        })
                    }
                });
                setAnalysisFeeResponse(analysisFeeResponse);
                setAddPriceTableStatus(false);
                setSameTestExist(false);
                setGetSelectedRowId([]);
                setResetSelectedIds(1);
                setNotificationMsg({ open: true, type: 'success', message: 'Successfully added to price table' });
            } else if (res.status === 400) {
                setAddPriceTableStatus(false);
                setResetSelectedIds(0);
                setNotificationMsg({ open: true, type: 'error', message: res.data });
                analysisFeeResponse && analysisFeeResponse.map((i: any) => {
                    resultData && resultData.map((j: any) => {
                        if ((i.id === j.quoteTestID) && (idSelected === j.quoteResultTableID)) {
                            setSameTestExist(true);
                        } else {
                            setSameTestExist(false);
                        }
                    })
                })
            }
        });
    }

    useEffect(() => {
        if (testId && (selectedIsSet === false)) {
            getBillingGroupId();
        }
    }, [testId])

    const getBillingGroupId = () => {
        getBillingGroupTest(testId, getPriceListId, selectedMatrixType).then((res: any) => {
            if (res.status === 200) {
                if (res?.data?.id === -1) {
                    setIsBillingGroup(false);
                } else {
                    setIsBillingGroup(true);
                    setSelectedMetal({ name: res?.data?.name, id: res?.data?.id });
                }
            }
        });
    }

    useEffect(() => {
        if (selectedMetal?.id) {
            getBillingGroupList();
        }
    }, [selectedMetal?.id])

    const getBillingGroupList = () => {
        getTestOfBillingGroup(selectedMetal?.id, testId).then((res: any) => {
            if (res.status === 200) {
                setBillingGroupTestList(res.data);
            }
        });
    }

    const handleGroupIds = (val: any) => {
        if (val.length === 0) {
            // Handle clear/empty selection
            setBillingGroupIds('');
            setBillingGroupList([]);
        } else {
            let item = [];
            val.map((i: any) => {
                item.push(i.id);
            })
            let ids = item.join(", ");
            setBillingGroupIds(ids);
            setBillingGroupList(val);
        }
    }

    return (
        <div style={{ paddingTop: '30px' }}>
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    '& > :not(style)': {
                        m: 0,
                        p: 0,
                        width: "100%",
                        height: "auto",
                        maxWidth: "100%"
                    }
                }}
            >
                <Container maxWidth="xl" sx={{ marginBottom: 5, marginTop: 5, padding: 0 }}>
                    <Card variant="outlined" sx={{ padding: 4 }}>
                        <Typography variant="h6" gutterBottom mt={2} mb={2}>
                            Analysis Fees / Test Specification
                        </Typography>
                        <Box sx={{ width: '100%' }}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                                    <Tab label="Analysis" {...a11yProps(0)} />
                                    <Tab label="Price List" {...a11yProps(1)} />
                                </Tabs>
                            </Box>
                            <TabPanel value={value} index={0}>
                                <Grid container spacing={2} sx={{ paddingTop: { xs: '10px', sm: '10px', md: 2 }, width: '100%' }}>
                                    <Grid item xs={12} sm={6} md={3} sx={{ paddingTop: 0, display: 'flex' }}>
                                        <FormControl fullWidth size="small">
                                            <MuiInputLabel
                                                id="analysis-matrix-type-label"
                                                sx={{
                                                    px: 0.5,
                                                    backgroundColor: '#fff',
                                                    fontSize: '0.78rem'
                                                }}
                                            >
                                                Matrix Type
                                            </MuiInputLabel>
                                            <Select
                                                labelId="analysis-matrix-type-label"
                                                id="analysis-matrix-type-select"
                                                label="Matrix Type"
                                                sx={{
                                                    width: '100%',
                                                    fontSize: "12px",
                                                    paddingLeft: 0,
                                                    '& .MuiSelect-select': {
                                                        fontSize: '12px',
                                                    },
                                                    '.css-hfutr2-MuiSvgIcon-root-MuiSelect-icon': {
                                                        color: '#1976d2'
                                                    }
                                                }}
                                                value={selectedMatrixType}
                                                onChange={(ev: any) => {
                                                    setSelectedMatrixType(ev.target.value);
                                                    setBillingGroupList([]);
                                                    setBillingGroupIds('');
                                                    setIsBillingGroup(false);
                                                    setTestName(null);
                                                }}
                                            >
                                                {matrixType.map((item: any, index: any) => (
                                                    <MenuItem key={index} value={item.id} sx={{ fontSize: '12px' }}>{item.name}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3} sx={{ paddingTop: { xs: '10px', sm: '10px', md: 0 }, display: 'flex' }}>
                                        <Autocomplete
                                            sx={{ width: '100%', paddingLeft: 0, fontSize: '12px' }}
                                            id="controlled-demo"
                                            size="small"
                                            noOptionsText="No Options"
                                            options={testList}
                                            value={testName}
                                            onChange={(event: any, newValue: any) => {
                                                setTestName(newValue || null);
                                                setSelectedIsSet(newValue?.isSet);
                                                setTestId(newValue?.id);
                                                // Reset billing group values when test changes
                                                setBillingGroupList([]);
                                                setBillingGroupIds('');
                                                setIsBillingGroup(false);
                                                setQuoteTestGroupId(0);
                                            }}
                                            onInputChange={(event: any, newInputValue: any, reason: string) => {
                                                if (reason === 'input') {
                                                    setSearchValue(newInputValue || '');
                                                    return;
                                                }

                                                if (reason === 'clear') {
                                                    setSearchValue('');
                                                    setTestName(null);
                                                    setTestId('');
                                                    setIsBillingGroup(false);
                                                    setTestList([]);
                                                }
                                            }}
                                            filterOptions={(x) => x}
                                            isOptionEqualToValue={(option: any, value: any) => option?.id === value?.id}
                                            getOptionLabel={(option: any) => {
                                                if (typeof option === 'string') {
                                                    return option;
                                                }

                                                if (!option) {
                                                    return '';
                                                }

                                                return option?.shortName
                                                    ? `${option.name} (${option.shortName})`
                                                    : (option?.name || '');
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Search Test"
                                                    sx={{ fontSize: '12px' }}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={3} md={2} sx={{ paddingTop: { xs: '10px', sm: '10px', md: 0 }, display: 'flex', alignItems: 'center' }}>
                                        <Tooltip
                                            title={
                                                [
                                                    selectedMatrixType ? `Matrix Type: ${matrixType.find((m: any) => m.id === selectedMatrixType)?.name ?? ''}` : '',
                                                    (testName as any)?.name ? `Search Test: ${(testName as any).name}` : '',
                                                ]
                                                    .filter(Boolean)
                                                    .join(' | ') || 'No values selected'
                                            }
                                            arrow
                                        >
                                            <Checkbox
                                                checked={searchInPriceList}
                                                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                                                    setSearchInPriceList(event.target.checked)
                                                }
                                            />
                                        </Tooltip>
                                        <InputLabel>
                                            <Typography variant="subtitle1" gutterBottom>
                                                In Price List
                                            </Typography>
                                        </InputLabel>
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={4} sx={{ paddingTop: { xs: '10px', sm: '10px', md: 0 }, paddingLeft: { xs: 0, sm: '10px', md: '10px' }, display: 'flex', justifyContent: { xs: 'left', sm: 'flex-end', md: 'left' } }}>
                                        <Tooltip title={!enableAddTestCheck ? "Please clear the errors then proceed" : ""} arrow>
                                            <span>
                                                <Button
                                                    color="primary"
                                                    variant="contained"
                                                    onClick={addSubmit}
                                                    disabled={!enableAddTestCheck}
                                                    size='medium'
                                                    startIcon={<ControlPointOutlinedIcon />}
                                                    sx={{
                                                        mt: { xs: 0, sm: 0, md: 0 },
                                                        width: { xs: '100%', sm: 'auto', md: 'auto' },
                                                        minWidth: 100,
                                                        maxWidth: 180,
                                                        height: 38,
                                                        fontSize: '12px',
                                                        padding: '0 16px',
                                                        boxSizing: 'border-box',
                                                    }}
                                                >
                                                    Add Test
                                                </Button>
                                            </span>
                                        </Tooltip>
                                    </Grid>
                                </Grid>
                                {isBillingGroup &&
                                    <Grid container spacing={2} sx={{ paddingTop: 1, width: '100%' }}>
                                        <Grid item xs={12} sm={12} md={3} sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }} />
                                        <Grid item xs={12} sm={8} md={3}>
                                            <Autocomplete
                                                multiple
                                                limitTags={2}
                                                id="multiple-limit-tags"
                                                options={billingGroupTestList}
                                                disableCloseOnSelect
                                                size="small"
                                                onChange={(event: any, newValue: any) => {
                                                    handleGroupIds(newValue);
                                                }}
                                                value={billingGroupList}
                                                filterOptions={createFilterOptions({
                                                    stringify: ({ name, shortName }) => `${name} - ${shortName} `,
                                                })}
                                                getOptionLabel={({ name, shortName }: any) => {
                                                    return `${name} - ${shortName}`;
                                                }}
                                                renderOption={(props, option, { selected }) => (
                                                    <li {...props}>
                                                        <Checkbox
                                                            icon={icon}
                                                            checkedIcon={checkedIcon}
                                                            style={{ marginRight: 8 }}
                                                            checked={selected}
                                                        />
                                                        {option.name} - {option.shortName}
                                                    </li>
                                                )}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Billing Group" />
                                                )}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={3} sx={{ display: { xs: 'block', sm: 'block', md: 'block' } }}>
                                            <FormControl fullWidth size="small">
                                                <MuiInputLabel
                                                    id="select-group-label"
                                                    sx={{
                                                        px: 0.5,
                                                        backgroundColor: '#fff',
                                                        fontSize: '0.78rem'
                                                    }}
                                                >
                                                    Select the group
                                                </MuiInputLabel>
                                                <Select
                                                    labelId="select-group-label"
                                                    id="select-group-select"
                                                    label="Select the group"
                                                    sx={{
                                                        width: '100%',
                                                        paddingLeft: 0,
                                                        '& .MuiSelect-select': {
                                                            fontSize: '0.78rem',
                                                        },
                                                        '.css-hfutr2-MuiSvgIcon-root-MuiSelect-icon': {
                                                            color: '#1976d2'
                                                        }
                                                    }}
                                                    onChange={(ev: any) => {
                                                        // Handle selection change
                                                        setQuoteTestGroupId(ev.target.value);
                                                    }}
                                                >
                                                    {getQuoteTestGroupList.map((item: any, index: any) => (
                                                        <MenuItem key={index} value={item.item2}>{item.item1}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                }
                                <Grid container spacing={2} sx={{ paddingTop: '30px', display: 'flex', justifyContent: 'space-between' }}>
                                    <Grid item xs={12} sm={12} md={12} sx={{ display: 'flex', justifyContent: 'right', gap: '10px' }}>
                                        {(analysisFeeResponse && analysisFeeResponse.length > 0) && (getSelectedRowId.length > 0) ? <div>
                                            <Button
                                                variant="contained"
                                                onClick={selectedRowDelete}
                                                startIcon={<DeleteOutlineOutlinedIcon />}
                                                tabIndex={-1}
                                                color="error"
                                            >
                                                Delete
                                            </Button>
                                        </div> : null}
                                        {(analysisFeeResponse?.length > 0 || analysisFeeResponse?.length > 0) && (getSelectedRowId?.length > 0 && resultTableStatus && isEnablePriceTable) ?
                                            <div>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    disabled={!resultTableStatus}
                                                    startIcon={<PostAddOutlinedIcon />}
                                                    onClick={handleAddToPriceTable}
                                                >
                                                    Add To Price Table
                                                </Button>
                                            </div> : null}
                                    </Grid>
                                </Grid>
                                {analysisFeeResponse?.length > 0 ?
                                    <>
                                        <SingleRowExpand
                                            pageName="Analysis"
                                            data={analysisFeeResponse}
                                            rowCount={rowCount}
                                            setAnalysisFeeResponse={setAnalysisFeeResponse}
                                            handleUpdate={handleUpdate}
                                            setHasChargesStatus={setHasChargesStatus}
                                            setGetSelectedRowId={setGetSelectedRowId}
                                            resetSelectedIds={resetSelectedIds}
                                            getSelectedRowId={getSelectedRowId}
                                            getPageNo={getPageNo}
                                            setIsEnablePriceTable={setIsEnablePriceTable}
                                            loading={loading}
                                        />
                                        <Typography variant="caption" display="block" gutterBottom> * <b>Grouped</b> : This is part of billing group</Typography>
                                        {!!snackbar && (
                                            <Snackbar
                                                open
                                                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                                                onClose={() => setSnackbar(null)}
                                                autoHideDuration={6000}
                                            >
                                                <Alert {...snackbar} onClose={() => setSnackbar(null)} />
                                            </Snackbar>
                                        )}
                                    </>
                                    : null}
                            </TabPanel>
                            <TabPanel value={value} index={1}>
                                <Grid container spacing={2} sx={{ paddingTop: 2 }}>
                                    <Grid item xs={12} sm={12} md={3} sx={{ paddingTop: 0, display: 'inline-flex' }}>
                                        <Grid item xs={12} sm={4} md={4} sx={{ paddingTop: 0 }}>
                                            <InputLabel>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    Matrix Type
                                                </Typography>
                                            </InputLabel>
                                        </Grid>
                                        <Grid item xs={12} sm={8} md={8} sx={{ paddingTop: 0 }}>
                                            <Select
                                                labelId="demo-customized-select-label"
                                                id="demo-controlled-open-select"
                                                sx={{
                                                    width: '100%',
                                                    paddingLeft: 0,
                                                    '.css-hfutr2-MuiSvgIcon-root-MuiSelect-icon': {
                                                        color: '#1976d2'
                                                    }
                                                }}
                                                defaultValue={1}
                                                size="small"
                                                onChange={(ev: any) => setSelectedPriceMatrixType(ev.target.value)}
                                            >
                                                {matrixType.map((item: any, index: any) => (
                                                    <MenuItem key={index} value={item.id}>{item.name}</MenuItem>
                                                ))}
                                            </Select>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={3} sx={{ paddingTop: 0, display: 'inline-flex' }}>
                                        <Grid item xs={12} sm={4} md={4} sx={{ paddingTop: 0, textAlign: { xs: 'left', sm: 'left', md: 'center' } }}>
                                            <InputLabel>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    Location
                                                </Typography>
                                            </InputLabel>
                                        </Grid>
                                        <Grid item xs={12} sm={8} md={8} sx={{ paddingTop: 0 }}>
                                            <Select
                                                labelId="demo-customized-select-label"
                                                id="demo-controlled-open-select"
                                                sx={{
                                                    width: '100%',
                                                    paddingLeft: 0,
                                                    '.css-hfutr2-MuiSvgIcon-root-MuiSelect-icon': {
                                                        color: '#1976d2'
                                                    }
                                                }}
                                                size="small"
                                                defaultValue={0}
                                                onChange={(ev: any) => setPriceLocationId(ev.target.value)}
                                            >
                                                {labLocationList.map((item: any, index: any) => (
                                                    <MenuItem key={index} value={item.id}>{item.name}</MenuItem>
                                                ))}
                                            </Select>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={6} sx={{ paddingTop: 0, display: 'inline-flex' }}>
                                        <Grid item xs={6} sm={4} md={4} sx={{ paddingTop: 0, textAlign: { xs: 'left', sm: 'left', md: 'center' } }}>
                                            <InputLabel>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    Test Name/Code
                                                </Typography>
                                            </InputLabel>
                                        </Grid>
                                        <Grid item xs={6} sm={4} md={4} sx={{ paddingTop: 0 }}>
                                            <OutlinedInput
                                                id="outlined-adornment-weight"
                                                sx={{ width: '100%' }}
                                                aria-describedby="outlined-weight-helper-text"
                                                placeholder="Enter Test Name or Code"
                                                onChange={(ev: any) => setPriceSearchValue(ev.target.value)}
                                                inputProps={{
                                                    'aria-label': 'weight',
                                                }}
                                                size="small"
                                            />
                                        </Grid>
                                        <Grid item xs={6} sm={4} md={4} style={{ paddingTop: 0 }}>
                                            <Tooltip title="Exact Match" arrow>
                                                <Checkbox
                                                    size="small"
                                                    checked={isMatchResult}
                                                    onChange={handleCheckbox}
                                                />
                                            </Tooltip>
                                            <Button
                                                color="primary"
                                                variant="contained"
                                                onClick={() => {
                                                    dispatch({ type: 'SEARCH_RESULT', payload: 1 });
                                                    addPriceListSubmit();
                                                }}
                                                disabled={!enableSearchCheck}
                                                startIcon={<ContentPasteSearchOutlinedIcon />}
                                            >Search</Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <PriceList
                                    priceList={priceList}
                                    getPriceListId={getPriceListId}
                                    quoteId={quoteId}
                                    matrixType={matrixType}
                                    labLocationList={labLocationList}
                                    setGetSelectedRowId={setGetSelectedRowId}
                                    tabStatus={tabStatus}
                                    setIsRowUpdate={setIsRowUpdate}
                                    getPageNo={getPageNo}
                                    rowCount={rowCount}
                                    selectedPriceMatrixType={selectedPriceMatrixType}
                                    priceLocationId={priceLocationId}
                                    priceSearchValue={priceSearchValue}
                                    analysisFeeResponse={analysisFeeResponse}
                                    updateAddStatus={updateAddStatus}
                                    analysisGridLoad={analysisGridLoad}
                                    value={value}
                                    currentRowUpdate={currentRowUpdate}
                                    addPriceListSubmit={addPriceListSubmit}
                                    selectedRowDelete={selectedRowDelete}
                                    getSelectedRowId={getSelectedRowId}
                                    setAnalysisFeeResponse={setAnalysisFeeResponse}
                                    handleUpdate={handleUpdate}
                                    setHasChargesStatus={setHasChargesStatus}
                                    resetSelectedIds={resetSelectedIds}
                                    resultTableStatus={resultTableStatus}
                                    handleAddToPriceTable={handleAddToPriceTable}
                                    setIsEnablePriceTable={setIsEnablePriceTable}
                                />
                            </TabPanel>
                            <AddPriceTable
                                open={addPriceTableStatus}
                                onClose={handleCloseAddPriceTable}
                                priceTables={priceTables}
                                getSelectedRowId={getSelectedRowId}
                                quoteID={quoteId}
                                analysisGetRow={analysisGetRow}
                                resultData={resultData}
                                summaryUpdateStatus={summaryUpdateStatus}
                                analysisFeeResponse={analysisFeeResponse}
                                setIdSelected={handleIdSelection}
                                submitPriceTable={submitPriceTable}
                                enableAddOnCheckbox={enableAddOnCheckbox}
                                selectedSuiteList={selectedSuiteList}
                            />
                        </Box>
                        <Stack sx={{ width: '100%', marginTop: 2 }} spacing={2}>
                            <Snackbar open={deleteError} autoHideDuration={5000} onClose={() => setDeleteError(false)}>
                                <Alert severity="error">
                                    <b>Selected test(s) cannot be deleted. Please delete the entry from the results table to delete the test(s).</b>
                                </Alert>
                            </Snackbar>
                            <Snackbar open={isRowUpdate} autoHideDuration={3000} onClose={() => setIsRowUpdate(false)}>
                                <Alert severity="success"><b>Updated Successfully.</b></Alert>
                            </Snackbar>
                            <Snackbar open={sameTestExist} autoHideDuration={3000} onClose={() => setSameTestExist(false)}>
                                <Alert severity="warning" onClose={() => setSameTestExist(false)}>
                                    <b>Selected test is already present in the result table</b>
                                </Alert>
                            </Snackbar>
                            <Snackbar open={isUpdateError} autoHideDuration={3000} onClose={() => setIsUpdateError(false)}>
                                <Alert severity="warning" onClose={() => setIsUpdateError(false)}><b>{updateErrorMsg}</b></Alert>
                            </Snackbar>
                            <Snackbar open={isRowDeleted} autoHideDuration={3000} onClose={() => setIsRowDeleted(false)}>
                                <Alert severity="success" onClose={() => setIsRowDeleted(false)}><b>Deleted Successfully.</b></Alert>
                            </Snackbar>
                            <Snackbar open={notFoundError} autoHideDuration={3000} onClose={() => setNotFoundError(false)}>
                                <Alert severity="warning" onClose={() => setNotFoundError(false)}><b>No test found!</b></Alert>
                            </Snackbar>
                            <Snackbar open={notificationMsg.open} autoHideDuration={3000} onClose={() => setNotificationMsg({ ...notificationMsg, open: false })}>
                                <Alert severity={notificationMsg.type as any} onClose={() => setNotificationMsg({ ...notificationMsg, open: false })}><b>{notificationMsg.message}</b></Alert>
                            </Snackbar>
                        </Stack>
                    </Card>
                    {billingGroupEnablePopup ?
                        <DeletePrompt
                            open={billingGroupEnablePopup}
                            onClose={() => setBillingGroupEnablePopup(false)}
                            handleTableDelete={() => handleTableDelete()}
                            billingGroupEnable={true}
                        />
                        : null}
                </Container>
            </Box>
            {(quoteId) ?
                <ResultPage
                    quoteID={quoteId}
                    getPriceTableResult={getPriceTableResult}
                    resultData={resultData}
                    summaryUpdateStatus={summaryUpdateStatus}
                    showSummaryTable={showSummaryTable}
                    priceTables={priceTables}
                    isEdit={isEdit}
                    resultTableNames={resultTableNames}
                    setSelectionTriggerMisc={setSelectionTriggerMisc}
                    saveAllTrigger={saveAllTrigger}
                />
                : null}
        </div >
    );
}
